import type { DefaultModalType } from '@chat-types/common';
import Modal from '@components/modal/Modal';
import strings from '@i18n/index';
import * as SC from '@components/modal/error/ErrorModal.style';
import useModalHook from '@hooks/useModalHook';

export type ErrorModalProps = {
  depth?: number;
  message?: string;
} & DefaultModalType;

const ErrorModal = ({ onConfirm, onCancel, message = strings.BASIC__.ERROR, depth = 1 }: ErrorModalProps) => {
  const { closeModal } = useModalHook();

  return (
    <Modal
      depth={depth}
      title="error"
      hideTitle
      onConfirm={() => {
        onConfirm?.();
        closeModal('errorModal');
      }}
      onCancel={() => {
        onCancel?.();
        closeModal('errorModal');
      }}
      hideCancelBtn
      isConfirmError
    >
      <SC.Wrapper dangerouslySetInnerHTML={{ __html: message }} />
    </Modal>
  );
};

export default ErrorModal;
